import { combineReducers } from 'redux';
import {
  GET_MESSAGE_SETTINGS_OPEN_SUCCESS,
  GET_THRID_CHAT_OPEN_SUCCESS,
  GET_COM_AUTH_SUCCESS,
  GET_MESSAGE_OPEN_SUCCESS,
  GET_COM_NOEXPIRE_OPEN_SUCCESS,
  AGENT_CONFIG_SUCCESS,
} from "../action-types/userInfo";
import moment from 'moment'

const messageSettingsOpen = (state = {}, action) => {
  if (action.type === GET_MESSAGE_SETTINGS_OPEN_SUCCESS) {
    return { ...state, ...action.data }
  }
  return state
}

// 第三方会话存档是否配置
const thirdChatAuth = (state = {}, action) => {
  if (action.type === GET_THRID_CHAT_OPEN_SUCCESS) {
    return { ...state, ...action.data, apiStatus: true }
  }
  return state
}

// 企业信息
const comAuthInfo = (state = {}, action) => {
  if (action.type === GET_COM_AUTH_SUCCESS) {
    return { ...state, ...action.data, apiStatus: true }
  }
  return state
}

// 自建应用配置信息
const messageOpenParams = (state = {}, action) => {
  if (action.type === GET_MESSAGE_OPEN_SUCCESS) {
    return { ...state, ...action.data, apiStatus: true }
  }
  return state
}

// 自建应用配置信息-自建应用购买
const companyNoExpire = (state = {}, action) => {
  if (action.type === GET_COM_NOEXPIRE_OPEN_SUCCESS) {
    let hasScrm = false
    if (action.data.expiredAt) {
      // scrm过期时间
      const expirationDate = moment(action.data.expiredAt);
      // 检查当前时间是否超过了过期时间
      const hasExpired = moment().isAfter(expirationDate);
      if (!hasExpired) {
        hasScrm = true;
      }
    }
    // 是否开通使用会话宝
    const isThrid = !(action.data?.hasChatFeature === null);
    // 只开通了会话宝
    const onLyThird = (action.data.licenseType == 0 && !hasScrm) && isThrid;
    return { ...state, ...action.data, apiStatus: true, isThrid, onLyThird, hasScrm }
  }
  return state
}
// 签名状态
const agentConfig = (state = {}, action) => {
  if (action.type === AGENT_CONFIG_SUCCESS) {
    return { ...state, ...action.data, apiStatus: true }
  }
  return state
}
export default combineReducers({
  messageSettingsOpen,
  thirdChatAuth,
  comAuthInfo,
  messageOpenParams,
  companyNoExpire,
  agentConfig,
})
